import { render, staticRenderFns } from "./dropdown-three-component.vue?vue&type=template&id=3b8526d3&"
import script from "./dropdown-three-component.vue?vue&type=script&lang=tsx&"
export * from "./dropdown-three-component.vue?vue&type=script&lang=tsx&"
import style0 from "./dropdown-three-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports